// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox-8a44bbb1","control":"control-35467d08","active":"active-87071fc7","rtl":"rtl-1ad38091"};